import * as R from 'ramda'

import redeemedAmount from '~/src/pos/retailOrder/redeemedAmount.js'

import shareAmount from './shareAmount.js'

// WHAT THE CUSTOMER PAYS, and the share of it each item carries.
//
// Everything that comes off the sale before the customer pays: the whole-order
// discount AND whatever is being redeemed. Both are shared across the items the
// same way, because the 統一發票 is built from items[].amount and has to declare
// what was actually paid.
//
// So `amount` is the figure the customer hands over -- which is why the total
// beside the checkout button, the earn suggestion and the award remark can all
// read it directly, with no arithmetic of their own.
//
// A MODULE OF ITS OWN so it can be tested. It used to be an anonymous function
// in pageConfig, which cannot be loaded outside a bundler -- pageConfig reaches
// Cashier.jsx and coact/saga -- and so the one assertion that would have caught
// the reopened-order bug could not be written at all. Runs before
// computeEarnPoints, which reads the `amount` this sets.
export default function computeAmount(value) {
  const { items } = value
  if (R.isNil(items)) return {}

  const total = R.reduce((acc, { subtotal }) => acc + subtotal, 0, items)

  const discount = value.discount || 0
  const reduction = discount + redeemedAmount(value)

  const subtotals = R.map(R.propOr(0, 'subtotal'), items)
  const shares = shareAmount(reduction, subtotals)

  const subAmounts = R.addIndex(R.map)(
    ({ subtotal }, index) => ({ amount: subtotal - shares[index] }),
    items,
  )

  return { amount: total - reduction, items: subAmounts }
}
